import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from './ui/dialog';
import { Info, Coins, TrendingUp, Rocket } from 'lucide-react';

const CreatorEconomicsModal = ({ trigger }) => (
  <Dialog>
    <DialogTrigger asChild>
      {trigger || (
        <button data-testid="creator-economics-btn" className="cf-btn-secondary text-sm">
          <Info className="w-4 h-4" /> How do I make money?
        </button>
      )}
    </DialogTrigger>
    <DialogContent className="bg-[#0B0A2A]/95 backdrop-blur-2xl border border-white/10 rounded-3xl text-white max-w-lg">
      <span className="cf-chip w-fit">Creator economics</span>
      <DialogTitle className="font-display text-2xl font-bold mt-3">
        Three ways your coin pays you
      </DialogTitle>
      <div className="space-y-3 mt-4">
        <Block icon={<Coins />} title="20% supply to you · 80% locked forever in LP">
          Exactly 20% of the supply mints to your wallet — never more. The other 80% is auto-paired with the ETH you attach at launch and locked forever in a burned Uniswap V3 LP position (nobody, not even you, can pull it out). If the LP step ever fails, the 80% is burned to 0x…dEaD instead — the 20/80 split is enforced at the contract level, no escape hatch.
        </Block>
        <Block icon={<TrendingUp />} title="0.5% on every trade. Forever.">
          Every on-chain transfer routes <span className="text-[#7DF9FF] font-semibold">0.5%</span> to your wallet automatically. Passive income for as long as the token trades. The other <span className="text-[#7DF9FF] font-semibold">1.0%</span> keeps CoinForge running.
        </Block>
        <Block icon={<Rocket />} title="Tradeable instantly">
          Because we seed a Uniswap V3 pool at launch, your coin is buyable on any DEX aggregator (Uniswap, 1inch, Matcha) the moment the tx confirms. Anyone can buy — you earn 0.5% royalties on every trade.
        </Block>
      </div>
      <p className="text-xs text-forge-muted mt-4 pt-4 border-t border-white/5 leading-relaxed">
        The 1.5% tax is hard-coded and immutable. Nobody — not even you — can change it after deploy.
      </p>
    </DialogContent>
  </Dialog>
);

const Block = ({ icon, title, children }) => (
  <div className="flex gap-3 p-4 rounded-2xl bg-white/[0.03] border border-white/5 hover:border-[#7DF9FF]/30 transition-colors">
    <div className="shrink-0 w-10 h-10 rounded-xl bg-gradient-to-br from-[#7DF9FF]/20 to-[#A78BFA]/20 flex items-center justify-center text-[#7DF9FF]">
      {React.cloneElement(icon, { className: 'w-5 h-5' })}
    </div>
    <div className="flex-1">
      <h4 className="font-display font-semibold text-white">{title}</h4>
      <p className="text-sm text-forge-muted mt-1 leading-relaxed">{children}</p>
    </div>
  </div>
);

export default CreatorEconomicsModal;
